import { RequiredIndicator, RequiredIndicatorPlacement } from '@wix/ambassador-forms-v4-form/types';
import { Checkbox as TPACheckbox } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { useFocusFieldEvent } from '../../contexts/events-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { FieldRichLabelWUT } from '../field-rich-label/field-rich-label-wut';
import { Widget } from '../widget/widget';
import styles from './checkbox-field-wut.module.scss';
import { classes } from './checkbox-field-wut.st.css';
export const CheckboxFieldWUT = ({ id, label, disabled = false, value = false, onChange, onFocus, onBlur, hasError = false, errorMessage, required, FieldLayout, requiredIndicatorType = RequiredIndicator.ASTERISK, requiredIndicatorPlacement = RequiredIndicatorPlacement.AFTER_FIELD_TITLE, widgetHtml, widgetEnabled })=>{
    const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
    const checkboxRef = useRef(null);
    const handleChange = useCallback((event)=>{
        onChange?.(event.checked);
    }, [
        onChange
    ]);
    useFocusFieldEvent(()=>{
        checkboxRef.current?.focus({
            preventScroll: true
        });
    }, id);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>null,
        renderInput: ()=>widgetHtml && widgetEnabled ? /*#__PURE__*/ React.createElement(Widget, {
                fieldId: id,
                widgetHtml: widgetHtml,
                onChange: onChange,
                value: value
            }) : /*#__PURE__*/ React.createElement("div", {
                onBlur: onBlur,
                onFocus: onFocus
            }, /*#__PURE__*/ React.createElement(TPACheckbox, {
                newErrorMessage: true,
                className: classNames(styles.checkbox, classes.root, classes.checkbox, {
                    [classes.error]: hasError,
                    [classes.hover]: forcedHover
                }),
                label: /*#__PURE__*/ React.createElement(FieldRichLabelWUT, {
                    label: label,
                    disabled: disabled,
                    required: required,
                    requiredIndicatorType: requiredIndicatorType,
                    requiredIndicatorPlacement: requiredIndicatorPlacement
                }),
                checked: Boolean(value),
                onChange: handleChange,
                disabled: disabled,
                error: hasError,
                errorMessage: errorMessage,
                required: required,
                showAsterisk: false,
                ref: checkboxRef
            })),
        renderDescription: ()=>null
    });
};

//# sourceMappingURL=checkbox-field-wut.js.map